import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { supabase } from "../supabase/supabaseClient";
import { useUser } from "../contexts/UserContext";
import ShareBar from "../components/ShareBar";   // 🔥 공유 기능 추가

export default function OpportunityDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useUser();

  const [item, setItem] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  // 데이터 로드
  async function fetchData() {
    const { data, error } = await supabase
      .from("opportunities")
      .select("*")
      .eq("id", Number(id))   // id는 반드시 Number 변환
      .single();

    if (error) {
      console.error(error);
      return;
    }

    setItem(data);
    setLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, [id]);

  // 🔥 삭제 기능
  async function handleDelete() {
    if (!window.confirm("정말 삭제하시겠습니까?")) return;

    const { error } = await supabase
      .from("opportunities")
      .delete()
      .eq("id", Number(id));

    if (error) {
      alert("Error: " + error.message);
      return;
    }

    alert("삭제가 완료되었습니다.");
    navigate("/opportunities");
  }

  if (loading) return <div className="p-6">Loading...</div>;
  if (!item) return <div className="p-6">Not found.</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">

      {/* 제목 + 관리자 버튼 */}
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-bold">{item.title}</h1>

        {user?.userType === "admin" && (
          <div className="flex gap-2">
            <Link
              to={`/opportunities/edit/${item.id}`}
              className="px-3 py-1 bg-black text-white rounded"
            >
              Edit
            </Link>

            <button
              onClick={handleDelete}
              className="px-3 py-1 bg-red-600 text-white rounded"
            >
              Delete
            </button>
          </div>
        )}
      </div>

      {/* 카테고리 */}
      <div className="inline-block px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700 mb-4">
        {item.category}
      </div>

      {/* Host/Region/Deadline */}
      <div className="text-gray-600 mb-4">
        {item.host && <div>Host: {item.host}</div>}
        {item.region && <div>Region: {item.region}</div>}
        {item.deadline && (
          <div>
            Deadline: {new Date(item.deadline).toLocaleDateString()}
          </div>
        )}
      </div>

      {/* Description */}
      {item.description && (
        <div className="whitespace-pre-line text-gray-800 leading-relaxed mb-6">
          {item.description}
        </div>
      )}

      {/* 🔥 공유 기능 ShareBar */}
      <div className="my-6">
        <ShareBar title={item.title} />
      </div>

      {/* 외부 링크 */}
      {item.url && (
        <a
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 font-medium"
        >
          View External Link →
        </a>
      )}
    </div>
  );
}
